﻿<!-- single-file components with a .vue extension -->
<template>
<div v-if="isOpen" :class="['modal-mask', modalClass]">
    <focus-trap :active="isOpen">
    <div class="modal-wrapper" @click="close(closeOnClickOutside)">
      <div class="modal-container">
        <div class="modal" :style="modalInlineMaxWidth">
          <div
            class="modal-content"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            aria-describedby="modal-content"
          >
            <button
              v-if="showCloseButton"
              :disabled="disableCloseButton"
              class="close-button"
              title="Luk (Esc)"
              type="button"
              data-test="modal-close"
              @click="close"
            >
              <span class="icon-cross" />
            </button>

            <div class="row">
              <div
                class="small-12 columns modal-inner-content"
                :class="{ 'push-down': spaceBottom }"
              >
                <div id="modal-title">
                  <slot name="title" />
                </div>
                <div id="modal-content">
                  <slot name="content" />
                </div>
                <slot name="footer" />
              </div>
            </div>

            <slot name="buttons" />
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'Modal',
  // inject: ['$validator'],
  props: {
    isOpen: {
      type: Boolean,
      default() {
        return false;
      }
    },
    closeOnClickOutside: {
      type: Boolean,
      default() {
        return false;
      }
    },
    disableCloseButton: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showCloseButton: {
      type: Boolean,
      default() {
        return true;
      }
    },
    spaceBottom: {
      type: Boolean,
      default() {
        return true;
      }
    },
    modalClass: {
      type: String,
      default() {
        return '';
      }
    },
    maxWidth: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      bodyElement: document.getElementsByTagName('body')[0]
    };
  },
  computed: {
    modalInlineMaxWidth() {
      return this.maxWidth !== null ? 'max-width: ' + this.maxWidth : '';
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    }
  },
  mounted() {
    const vm = this;

    $(document).keyup((e) => {
      if (e.keyCode == 27) {
        vm.close();
      }
    });
  },
  methods: {
    close(closeVal = true) {
      if (closeVal) {
        this.$emit('close');
      }
    },
    disableScroll() {
      // https://www.geeksforgeeks.org/how-to-disable-scrolling-temporarily-using-javascript/
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      window.onscroll = () => {
        window.scrollTo(scrollLeft, scrollTop);
      };
    },
    enableScroll() {
      window.onscroll = () => {};
    }
  }
};
</script>
